import { BreadcrumbItems } from '@/components/custom-breadcrumb/custom-breadcrumb.types';
import { useLocation } from 'react-router';

export const useBreadcrumbs = () => {
  const { pathname } = useLocation();
  const paths = pathname.split('/');
  paths[0] = '/';
  let breadcrumbsItems: BreadcrumbItems = paths.map((path, index) => ({
    title: index === 0 ? 'dashboard' : path.split('-').join(' '),
    path: `${path}`,
  }));
  const clonedItems = [...breadcrumbsItems];
  breadcrumbsItems = breadcrumbsItems.map((item, index) => {
    if (index === 1) {
      const processedItem = { ...item, path: `/${item.path}` };
      clonedItems[index] = processedItem;
      return processedItem;
    }
    if (index > 1) {
      const processedItem = { ...item, path: `${clonedItems[index - 1].path}/${item.path}` };
      clonedItems[index] = processedItem;
      return processedItem;
    }
    return item;
  });

  if (breadcrumbsItems.length > 0) {
    breadcrumbsItems[breadcrumbsItems.length - 1].path = undefined;
  }

  return breadcrumbsItems;
};
